import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AddGuidanceForm from './AddGuidanceForm';
import AddGuidanceTypeForm from './AddGuidanceTypeForm.js';
import AddGuidanceContentForm from './AddGuidanceContentForm';
import AddRoadmapForm from './AddRoadmapForm.js';
import ManageGuidance from './ManageGuidance';
import ManageGuidanceArticle from './ManageGuidanceArticle';
import ManageGuidanceTypes from './ManageGuidanceTypes';
import ViewUserActivity from './ViewUserActivity';
import ManageUsers from './ManageUsers';
import AddQuestionGroupForm from './AddQuestionGroupForm';
import QuestionGroups from './QuestionGroups';
import AddQuestionForm from './AddQuestionForm';
import EditQuestionForm from './EditQuestionForm';
import ShowQuestionTree from './ShowQuestionTree';
import AddNotificationForm from './AddNotificationForm';
import AddRoadmapItemForm from './AddRoadmapItemForm';
import AddCalendarTypeForm from './AddCalendarTypeForm';
import AceGPT from './AceGPT';
import SystemSettings from './SystemSettings.js';
import AddQuestionGroupTypeForm from './AddQuestionGroupTypeForm';
import CareHomes from './CareHomes';
import GenerateArticles from './GenerateArticles.js';
import ModerationCommunity from './ModerationCommunity.js';
import ModerationMessages from './ModerationMessages.js';



const AdminRoutes = () => {


    return (
        <Routes>
            <Route path='/add-guidance' element={<AddGuidanceForm />} />
            <Route path='/add-guidance/:guidanceId' element={<AddGuidanceForm />} />
            <Route path='/add-guidance-type' element={<AddGuidanceTypeForm />} />
            <Route path="/ManageGuidanceArticle/:guidanceId" element={<ManageGuidanceArticle />} />
            <Route path="/AddGuidanceContentForm/:guidanceId" element={<AddGuidanceContentForm />} />
            <Route path='/manage-guidance' element={<ManageGuidance />} />
            <Route path='/manage-guidance-types' element={<ManageGuidanceTypes />} />
            <Route path='/view-user-activity' element={<ViewUserActivity />} />
            <Route path='/manage-users' element={<ManageUsers />} />
            <Route path='/add-question-group' element={<AddQuestionGroupForm />} />
            <Route path='/add-roadmap-group' element={<AddRoadmapForm />} />
            <Route path='/add-question' element={<QuestionGroups />} />
            <Route path="/add-question-form/:id" element={<AddQuestionForm />} />
            <Route path="/edit-question-form/:id" element={<EditQuestionForm />} />
            <Route path='/show-question-tree' element={<ShowQuestionTree />} />
            <Route path='/add-notification' element={<AddNotificationForm />} />
            <Route path='/add-roadmap' element={<AddRoadmapItemForm />} />
            <Route path='/add-calendar-type' element={<AddCalendarTypeForm />} />
            <Route path='/ace-gpt' element={<AceGPT />} />
            <Route path='/add-question-group-type' element={<AddQuestionGroupTypeForm />} />
            <Route path='/care-homes' element={<CareHomes />} />
            <Route path='/system-settings' element={<SystemSettings />} />
            <Route path='/generate-articles' element={<GenerateArticles />} />        
            <Route path='/moderation-community' element={<ModerationCommunity />} />
            <Route path='/moderation-messages' element={<ModerationMessages />} />
                
            
            
        </Routes>
    );
};

export default AdminRoutes;
